const valuePropCarouselAlt = {
  displayField: 'internalName',
  name: 'Value Prop Carousel ALT',
  description: '',
  fields: [
    {
      id: 'internalName',
      name: 'Internal Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
    },
    {
      id: 'backgroundColor',
      name: 'Background color',
      type: 'Boolean',
      localized: false,
      required: true,
      validations: [],
      defaultValue: {'en-US': true},
      disabled: false,
      omitted: false,
    },
    {
      id: 'valuePropCardContentAlt',
      name: 'Value Prop Card Content ALT',
      type: 'Array',
      localized: false,
      required: true,
      validations: [
        {
          size: {
            min: 4,
          },
          message: 'Please provide a minimum of 4 Value Prop Card Content Alt',
        },
      ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: ['valuePropCardContentAlt'],
            message: 'Please provide a Value Prop Card Content Alt',
          },
        ],
        linkType: 'Entry',
      },
    },
  ],
  sys: {
    id: 'valuePropCarouselAlt',
    version: 12,
    updatedAt: '2024-05-07T19:19:01.083Z',
  },
};
export default valuePropCarouselAlt;
